import camelCase from 'lodash/camelCase'
import snakeCase from 'lodash/snakeCase'

const api =
  process.env.REACT_APP_CONTACTS_API_URL || '/api'

function toCamel(o) {
  let newO
  let origKey
  let newKey
  let value
  if (o instanceof Array) {
    newO = []
    for (origKey in o) {
      value = o[origKey]
      if (typeof value === 'object') {
        value = toCamel(value)
      }
      newO.push(value)
    }
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = camelCase(origKey)
        value = o[origKey]
        if (
          value instanceof Array ||
          (value !== null && value.constructor === Object)
        ) {
          value = toCamel(value)
        }
        newO[newKey] = value
      }
    }
  }
  return newO
}

function toSnake(o) {
  let newO
  let origKey
  let newKey
  let value
  if (o instanceof Array) {
    newO = []
    for (origKey in o) {
      value = o[origKey]
      if (typeof value === 'object') {
        value = toSnake(value)
      }
      newO.push(value)
    }
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = snakeCase(origKey)
        value = o[origKey]
        if (
          value instanceof Array ||
          (value !== null && value.constructor === Object)
        ) {
          value = toSnake(value)
        }
        newO[newKey] = value
      }
    }
  }
  return newO
}

function getHeader(accessToken,contentType='application/json') {
  const headers = new Headers()
  headers.append('Authorization', accessToken)
  if (contentType) {
     headers.append('Content-Type', contentType)
  }
  return headers
}

export function signIn(values) {
  values = toSnake(values)
  const obj = {}
  return fetch(`${api}/user/signin`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(values),
  })
    .then((resp) => {
      obj.accessToken = resp.headers.get('Access-token')
      //obj.client = resp.headers.get('client')
      //obj.uid = resp.headers.get('Uid')
      return resp.json()
    })
    .then((response) => {
      response.headers = {}
      response.headers.accessToken = obj.accessToken
      //response.headers.client = obj.client
      //response.headers.uid = obj.uid
      return toCamel(response)
    })
}

export function signUp(values) {
  const snakeValues = toSnake(values)
  const obj = {}
  return fetch(`${api}/user/signup`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(snakeValues),
  }).then((resp) => {
      obj.accessToken = resp.headers.get('Access-token')
      return resp.json()
    })
    .then((response) => {
      response.headers = {}
      response.headers.accessToken = obj.accessToken

      return toCamel(response)
    })
}

export function confirmRegistration(values) {
  const snakeValues = toSnake(values)
  const obj = {}
  return fetch(`${api}/user/confirm`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(snakeValues),
  }).then((resp) => {
      obj.accessToken = resp.headers.get('Access-token')
      return resp.json()
    })
    .then((response) => {
      response.headers = {}
      response.headers.accessToken = obj.accessToken

      return toCamel(response)
    })
}

export function regenerateOTP(values) {
  const snakeValues = toSnake(values)
  return fetch(`${api}/user/regen_otp`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(snakeValues),
  }).then(resp => resp.json())
}

export function checkForResetPwdStatus(values) {
  const snakeValues = toSnake(values)
  return fetch(`${api}/user/pwd/reset/status`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(snakeValues),
  }).then(resp => resp.json())
}

export function getBasicProfile(accessToken) {
  return fetch(`${api}/personal_info`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function saveBasicProfile(accessToken, formData) {
//  const snakeValues = toSnake(values)
  return fetch(`${api}/personal_info`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
   // body: JSON.stringify(formData),
      body: formData,
  }).then(resp => resp.json())
}

export function getAddresses(accessToken) {
  return fetch(`${api}/addresses`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getCountries(accessToken) {
  return fetch(`${api}/countries`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getStates(accessToken, country_id) {
  return fetch(`${api}/countries/${country_id}/states`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getTPOCountries(accessToken) {
  return fetch(`${api}/tpo_registration/countries`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function saveContactInfo(accessToken, values) {
  //const snakeValues = toSnake(values)
  return fetch(`${api}/addresses`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function getEducationList(accessToken) {
  return fetch(`${api}/education`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())  
}

export function addEducationItem(accessToken, values) {
  const snakeValues = toSnake(values)
  return fetch(`${api}/education`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(snakeValues),
  }).then(resp => resp.json())
}

export function updateEducationItem(accessToken, values) {
  const snakeValues = toSnake(values)
  console.log(`${api}/education/${values.id}`)
  return fetch(`${api}/education/${values.id}`, {
    method: 'PATCH',
    headers: getHeader(accessToken),
    body: JSON.stringify(snakeValues),
  }).then(resp => resp.json())
}

export function deleteEducationItem(accessToken, id) {
  return fetch(`${api}/education/${id}`, {
    method: 'DELETE',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())  
}

export function getWorkExperienceList(accessToken) {
  return fetch(`${api}/work_histories`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())  
}

export function addWorkExperienceItem(accessToken, values) {
  const snakeValues = toSnake(values)
  return fetch(`${api}/work_histories`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(snakeValues),
  }).then(resp => resp.json())
}

export function updateWorkExperienceItem(accessToken, values) {
  const snakeValues = toSnake(values)
  console.log(`${api}/work_histories/${values.id}`)
  return fetch(`${api}/work_histories/${values.id}`, {
    method: 'PATCH',
    headers: getHeader(accessToken),
    body: JSON.stringify(snakeValues),
  }).then(resp => resp.json())
}

export function deleteWorkExperienceItem(accessToken, id) {
  return fetch(`${api}/work_histories/${id}`, {
    method: 'DELETE',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())  
}

export function getCertificationLevels(accessToken) {
  return fetch(`${api}/certification_level_list`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getTestTracks(accessToken, type) {
  return fetch(`${api}/test_track_list/${type}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getPaymentModes(accessToken) {
  return fetch(`${api}/payment_mode_list`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getMcTopics(accessToken) {
  return fetch(`${api}/mc_topics`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getFeeByLevel(accessToken, certification_level_id, certification_type_id) {
  return fetch(`${api}/get_fee_by_leavel/${certification_level_id}/${certification_type_id}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}


export function getFeeByCertificationType(certification_type) {
  return fetch(`${api}/get_fee_by_certification_type/${certification_type}`, {
    method: 'GET',
  }).then(resp => resp.json())
}

export function calculateDiscount(accessToken, certification_level_id, certification_type_id, discount_code) {
  return fetch(`${api}/calculate_discount/${certification_level_id}/${certification_type_id}/${discount_code}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function calculateMCDiscount(accessToken, certification_level_id, certification_type_id, discount_code, mc_topic_count) {
  return fetch(`${api}/calculate_mc_discount/${certification_level_id}/${certification_type_id}/${discount_code}/${mc_topic_count}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function calculateTpoDiscount(accessToken, certification_type_id, discount_code, amount) {
  return fetch(`${api}/calculate_tpo_discount//${certification_type_id}/${discount_code}/${amount}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function saveFullCertifications(accessToken, values) {
  return fetch(`${api}/full_certifications`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function saveMicroCredentialsCertifications(accessToken, values) {
  return fetch(`${api}/micro_credentials_certifications`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function getOpportunities(accessToken) {
  return fetch(`${api}/opportunities`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function getOpportunity(accessToken, opportunityId) {
  return fetch(`${api}/opportunities/${opportunityId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function saveOpportunity(accessToken, formData) {
  return fetch(`${api}/opportunities`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(toSnake(formData)),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function updateOpportunity(accessToken, formData) {
  return fetch(`${api}/opportunities/${formData.opportunityId}`, {
    method: 'PUT',
    headers: getHeader(accessToken),
    body: JSON.stringify(toSnake(formData)),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function applyForOpportunity(accessToken, opportunityId) {
  return fetch(`${api}/opportunity/apply?id=${opportunityId}`, {
    method: 'PUT',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getAppliedOpportunities(accessToken) {
  return fetch(`${api}/user/opportunities`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function searchOpportunities(accessToken, queryStr) {
  return fetch(`${api}/opportunities/search?query=${queryStr}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getTPOReferences(accessToken) {
  return fetch(`${api}/tpo_references`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getTeachingAssociations(accessToken) {
  return fetch(`${api}/teaching_associations`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getWorkingPositions(accessToken) {
  return fetch(`${api}/working_positions`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getTeachingAssociationOthers(accessToken) {
  return fetch(`${api}/teaching_association_others`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getTestCenters(accessToken) {
  return fetch(`${api}/test_centers`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getTestCentersByCountry(accessToken, country_id) {
  return fetch(`${api}/test_centers_country/${country_id}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getTPOTestTracks(accessToken, country_id) {
  return fetch(`${api}/tpo_test_track_list/${country_id}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getTPOTimeSlot(accessToken, testTrackId, primary){
  return fetch(`${api}/get_test_track_time_slots/${testTrackId}/${primary}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getTPOTrackFee(accessToken, testTrackId){
  return fetch(`${api}/tpo/track_fee/${testTrackId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getTPOCountryFee(accessToken, countryId){
  return fetch(`${api}/get_tpo_fee/${countryId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getPayments(accessToken) {
  return fetch(`${api}/payments`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function forgotPassword(values) {
  const snakeValues = toSnake(values)
  return fetch(`${api}/user/forgot_password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(snakeValues),
  }).then(resp => resp.json())
}

export function tokenLogin(values) {
  const snakeValues = toSnake(values)
  const obj = {}
  return fetch(`${api}/user/token_login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(snakeValues),
  }).then((resp) => {
      obj.accessToken = resp.headers.get('Access-token')
      return resp.json()
    })
    .then((response) => {
      response.headers = {}
      response.headers.accessToken = obj.accessToken

      return toCamel(response)
    })
}


export function getResume(accessToken) {
  return fetch(`${api}/resume`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function saveResume(accessToken, formData) {
//  const snakeValues = toSnake(values)
  return fetch(`${api}/resume`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
   // body: JSON.stringify(formData),
      body: formData,
  }).then(resp => resp.json())
}

export function proceedPayment(accessToken, payment_id) {
  return fetch(`${api}/proceed_payment/${payment_id}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())

}

export function getTpoReferenceSub(reference_id) {
  return fetch(`${api}/tpo_reference_sub/${reference_id}`, {
    method: 'GET',
  }).then(resp => resp.json())
}

export function getuserForRegistration(accessToken) {
  return fetch(`${api}/user/fetchuserreg`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function saveTPoRegistrationLoggedin(accessToken, values) {
  return fetch(`${api}/tpo_certifications`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}


export function updateTPoRegistration(accessToken, values) {
  return fetch(`${api}/tpo_certification/update`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function getTPORegistrationStatus(accessToken) {
  return fetch(`${api}/tpo/reg/status`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
 
}

export function getTPOLocation(accessToken, testCenterId){
  return fetch(`${api}/test_location/${testCenterId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function saveCentaCertification(values){
  const obj = {}
  return fetch(`${api}/centa/full_certifications`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(values),
  }).then((resp) => {
      obj.accessToken = resp.headers.get('Access-token')
      return resp.json()
    })
    .then((response) => {
      response.headers = {}
      response.headers.accessToken = obj.accessToken
      return toCamel(response)
  })
}

export function saveCentaMicroCredentailCertifications(values){
  const obj = {}
  return fetch(`${api}/centa/micro_credentials_certifications`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(values),
  }).then((resp) => {
      obj.accessToken = resp.headers.get('Access-token')
      return resp.json()
    })
    .then((response) => {
      response.headers = {}
      response.headers.accessToken = obj.accessToken
      return toCamel(response)
  })
}

export function saveCentaTPOCertifications(values, accessToken){
  const obj = {}
  return fetch(`${api}/centa/tpo_certifications`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then((resp) => {
      obj.accessToken = resp.headers.get('Access-token')
      return resp.json()
    })
    .then((response) => {
      response.headers = {}
      response.headers.accessToken = obj.accessToken
      return toCamel(response)
  })
}

export function confirmOTPRegistration(values){
   const obj = {}
   return fetch(`${api}/user/confirm_otp/certification`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(values),
  }).then((resp) => {
      obj.accessToken = resp.headers.get('Access-token')
      return resp.json()
    })
    .then((response) => {
      response.headers = {}
      response.headers.accessToken = obj.accessToken

      return toCamel(response)
  })
}

/** Save partial tpo information start */

export function saveRegistrationPersonalInfo(accessToken, values) {
  return fetch(`${api}/centa/registration/save_personal_info`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}


export function saveRegistrationUserDetails(accessToken, values) {
  return fetch(`${api}/centa/registration/user_detail`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function saveTPOPartialTPOCert(accessToken, values) {
  return fetch(`${api}/centa/tpo/partial/tpo_cert`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

/** Save partial tpo information end */

export function tpoAchievements(accessToken) {
  return fetch(`${api}/tpo_achievements`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function saveTPoRegUserDetailAlone(values) {
  return fetch(`${api}/centa/tpo/user_details_save`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}


export function genOTPForRegistration(values) {
  return fetch(`${api}/centa/registration/otp/gen`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function confirmOTPForRegistration(values) {
  const obj = {}
  return fetch(`${api}/centa/registration/otp/confirm`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(values),
  }).then((resp) => {
      obj.accessToken = resp.headers.get('Access-token')
      return resp.json()
    })
    .then((response) => {
      response.headers = {}
      response.headers.accessToken = obj.accessToken

      return response
    })
}

export function getRegisteredUsers(accessToken, certification, testCycle, page){
  return fetch(`${api}/admin/registered_users/${certification}/${testCycle}/${page}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function notifyRegisteredUsers(accessToken, values) {
  return fetch(`${api}/admin/notify_registered_user`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function mcAchievements(accessToken) {
  return fetch(`${api}/mc_achievements`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function fcAchievements(accessToken) {
  return fetch(`${api}/fc_achievements`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function fetchRegDetails(accessToken, certification){
  return fetch(`${api}/reg_details/${certification}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function fetchAdminMCRegDetails(accessToken, certification){
  return fetch(`${api}/admin/mc_registration_details/${certification}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function fetchAdminUserDetails(accessToken, page, type, search_key){
  return fetch(`${api}/admin/user_details/${page}?type=${type}&search_key=${search_key}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function validateEmail(email){
  return fetch(`${api}/user/validate/email/${email}`, {
    method: 'GET',
  }).then(resp => resp.json())
}

export function validateUserName(userName){
  return fetch(`${api}/user/validate/user_name/${userName}`, {
    method: 'GET',
  }).then(resp => resp.json())
}

export function validatePhone(phone){
  return fetch(`${api}/user/validate/phone/${phone}`, {
    method: 'GET',
  }).then(resp => resp.json())
}

/*export function getInvoiceDetails(accessToken, paymentId){
  var FileSaver = require('file-saver');
  return fetch(`${api}/invoice/${paymentId}.pdf`, {
    method: 'GET',
    headers: getHeader(accessToken),
    responseType: 'blob',
  }).then((response) => {
    FileSaver.saveAs(new Blob([response.data]),"invoice.pdf");
  });
}*/

export function getInvoiceDetails(accessToken, paymentId){
  var FileSaver = require('file-saver');
  return fetch(`${api}/invoice/${paymentId}.pdf`, {
    method: 'GET',
    headers: getHeader(accessToken),
    responseType: 'blob',
  }).then((response) => {
    console.log(response)
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'file.pdf');
    document.body.appendChild(link);
    link.click();
  });
}

export function resetPassword(accessToken, values){
  return fetch(`${api}/password/reset`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function resetUserName(accessToken, values){
  return fetch(`${api}/username/reset`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function fetchTPORegStatus(accessToken){
  return fetch(`${api}/tpo/registration/check`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function searchRegistrations(accessToken, values){
  return fetch(`${api}/admin/search/reg`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function fetchAdminTPORegDetail(accessToken, tpoCertId){
  return fetch(`${api}/admin/tpo/reg_detail/${tpoCertId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function adminUpdateTPORegistration(accessToken, values){
  return fetch(`${api}/admin/tpo/update`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function getTPODiscountPerTrack(accessToken, ceritfication_type, discount_code, amount, cert_part_id){
  return fetch(`${api}/calculate_tpo_discount?certification_type=${ceritfication_type}&discount_code=${discount_code}&amount=${amount}&cert_part_id=${cert_part_id}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function getTQDiscountPerTrack(accessToken, ceritfication_type, discount_code, amount, tq_test_track_id, selected_add_on){
  return fetch(`${api}/calculate_tq_discount?certification_type=${ceritfication_type}&discount_code=${discount_code}&amount=${amount}&tq_test_track_id=${tq_test_track_id}&global_type_id=${selected_add_on}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function exportTPORegData(accessToken, test_cycle_id, export_page){
  return fetch(`${api}/admin/tpo/export/${test_cycle_id}/${export_page}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function partialExportTPORegData(accessToken, test_cycle_id){
  return fetch(`${api}/tpo_partial_registration/export/${test_cycle_id}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getAdminRegistrationFeeDetails(accessToken, certification){
  return fetch(`${api}/admin/fee/${certification}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function adminRegistrationFeeModify(accessToken, values){
  return fetch(`${api}/admin/fee`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function getTPOReport(accessToken, rollno, year){
  return fetch(`${api}/reports/tpo_repots/${rollno}/${year}`, {
    method: 'GET',
    headers: getHeader(accessToken),
    responseType: 'application/octet-stream',
  }).then((resp) => {
      let contentType = (resp.headers.get('content-type'))
      let contentTypeVal = "application/octet-stream"
      if(contentType == contentTypeVal){
        console.log('inside if of content type check')
        return resp.blob();
      }else{
        console.log('inside else of content type check')
        return resp    
      }
   })  
  //}).then(function(blob) {
  //  const url = window.URL.createObjectURL(blob);
  //  const link = document.createElement('a');
  //  link.href = url;
  //  link.setAttribute('download', 'file.pdf');
  //  document.body.appendChild(link);
  //  link.click();    
  //});
}

export function getPaidRegistrations(accessToken){
  return fetch(`${api}/registrations/mysubmissions`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function fetchMCSubmissionDetails(accessToken, mcCertTopicId){
  return fetch(`${api}/uploads/mc_cert_topic/${mcCertTopicId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function fetchFCSubmissionDetails(accessToken, fullCertId){
  return fetch(`${api}/uploads/fc_cert/${fullCertId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function fetchTQSubmissionDetails(accessToken, tqCertDetailId){
  console.log(tqCertDetailId)
  return fetch(`${api}/uploads/tq_cert/${tqCertDetailId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function uploadCertArtifact(accessToken, formData) {
//  const snakeValues = toSnake(values)
  return fetch(`${api}/uploads/upload/artifact`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
   // body: JSON.stringify(formData),
      body: formData,
  }).then(resp => resp.json())
}

export function modifyUploadArtifact(accessToken, formData) {
//  const snakeValues = toSnake(values)
  return fetch(`${api}/uploads/modify/artifact`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
   // body: JSON.stringify(formData),
      body: formData,
  }).then(resp => resp.json())
}

export function fetchSubReviewerRegList(accessToken, cert_type, page){
  return fetch(`${api}/uploads/reviewer/list/reg/${cert_type}/${page}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function fetchAdminTPOUploadList(accessToken){
  return fetch(`${api}/admin/upload_types`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function uploadAdminTPO(accessToken, formData) {
  return fetch(`${api}/admin/tpo_upload_artifact`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

export function modifyTPOUploadArtifact(accessToken, formData) {
  return fetch(`${api}/admin/tpo_modify_artifact`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

export function fetchTPOSampleQuestions(accessToken, certification){
  return fetch(`${api}/user/tpo_questions_download/${certification}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function saveSubmissionCycleDates(accessToken, values) {
  const snakeValues = toSnake(values)
  return fetch(`${api}/uploads/reviewer/cycle/configure`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(snakeValues),
  }).then(resp => resp.json())
}

export function userReferral(accessToken, values){
  return fetch(`${api}/user_referral`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function exportUserRegData(accessToken, start){
  return fetch(`${api}/admin/user/export/${start}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminReferralDisplay(accessToken, pageNo){
  return fetch(`${api}/admin/user_referrals/all/${pageNo}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function userHallticketDetails(accessToken){
  return fetch(`${api}/hallticket/details`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminNewRoadmap(accessToken, values){
  return fetch(`${api}/admin/new_roadmap`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function adminRoadmapDisplay(accessToken, certification_type_id){
  return fetch(`${api}/admin/display_roadmap/${certification_type_id}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function downloadHallticket(accessToken, hallTicketId){
  return fetch(`${api}/hallticket/gen/${hallTicketId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
   responseType: 'application/pdf',
  }).then((resp) => {
      let contentType = (resp.headers.get('content-type'))
      let contentTypeVal = "application/pdf"
      if(contentType == contentTypeVal){
        console.log('inside if of content type check')
        return resp.blob();
      }else{
        console.log('inside else of content type check')
        return resp.blob();    
      }
   })
}

export function exportTPOHallTicketData(accessToken, start){
  return fetch(`${api}/admin/hallticket/export/${start}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

//---------------------------------------------------------------------------------------------
// Admin TPO Report Download Count - API start
//---------------------------------------------------------------------------------------------

export function exportTPOReportDownloadData(accessToken, start_id, test_cycle_id){
  return fetch(`${api}/admin/tpo_report/download_count/export/${start_id}/${test_cycle_id}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

//---------------------------------------------------------------------------------------------
//Admin TPO Report Download Count - API end
//---------------------------------------------------------------------------------------------

export function getTQTestTracks(accessToken, certification_name){
  return fetch(`${api}/tq_test_tracks?certification_name=${certification_name}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function getTQTestDates(accessToken,test_center_id){
  return fetch(`${api}/tq_test_dates/${test_center_id}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function saveTqCertifications(accessToken, values) {
  return fetch(`${api}/tq_certifications`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function adminNewCompetency(accessToken, values){
  return fetch(`${api}/admin/new_competency`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function adminCompetencyDisplay(accessToken, roadmap_id){
  return fetch(`${api}/admin/display_competency/${roadmap_id}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminDropDownCompetencyDisplay(accessToken, roadmap_id, competency_id){
  return fetch(`${api}/admin/sequence_display_competency/${roadmap_id}/${competency_id}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminCompetencySequenceUpdate(accessToken, values){
  return fetch(`${api}/admin/mc_competency_seq_update`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function adminSelectedSequenceDisplay(accessToken, competency_id){
  return fetch(`${api}/admin/mc_competency/selected_sequence/${competency_id}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminCompetencySetMainFlow(accessToken, mainParent){
  return fetch(`${api}/admin/mc_competency/set_main_flow/${mainParent}`, {
    method: 'POST',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminFlowChartDisplay(accessToken, roadmapId){
  return fetch(`${api}/admin/mc_competency_flow_chart/${roadmapId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminResourceLevelsBox(accessToken){
  return fetch(`${api}/admin/mc_competency/resources/levels`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminResourceTracksBox(accessToken){
  return fetch(`${api}/admin/mc_competency/resources/tracks`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminResourceDetails(accessToken, mcCompetencyId, certificationLevelId, testTrackId) {
  return fetch (`${api}/admin/mc_competency/resources/${mcCompetencyId}/${certificationLevelId}/${testTrackId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function addAdminResource(accessToken, values, competencyId, type){
  values = toSnake(values)
  return fetch(`${api}/admin/mc_competency/resources/new_add//${competencyId}/${type}`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function getTqTestCenters(accessToken) {
  return fetch(`${api}/tq_test_centers`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

//------------------------------------------------------------------------------------------------------
//Render Roadmap based on Registration - Version
export function userRoadmapDetails(accessToken) {
  return fetch (`${api}/user/mc_roadmap/details`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function userRenderCompetenciesOfRoadmap(accessToken, topicId) {
  return fetch (`${api}/user/display/all_competencies/${topicId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}
//------------------------------------------------------------------------------------------------------

export function saveCentaTQCertifications(values){
  const obj = {}
  return fetch(`${api}/centa/tq_certifications`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(values),
  }).then((resp) => {
      obj.accessToken = resp.headers.get('Access-token')
      return resp.json()
    })
    .then((response) => {
      response.headers = {}
      response.headers.accessToken = obj.accessToken
      return toCamel(response)
  })
}

export function updateCentaTQCertification(accessToken, values){
  const obj = {}
  return fetch(`${api}/tq_certification/update`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then((resp) => {
      obj.accessToken = resp.headers.get('Access-token')
      return resp.json()
    })
    .then((response) => {
      response.headers = {}
      response.headers.accessToken = obj.accessToken
      return toCamel(response)
  })
}

export function adminOpportunityUsersDisplay(accessToken, opportunityId){
  return fetch(`${api}/admin/opportunity/users/${opportunityId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}


//------------------------------------------------------------------------------------------------------
//Render Roadmap based on Registration - Version
export function userRenderIndividualRoadmap(accessToken, certificationParticipationId) {
  return fetch (`${api}/user/mc_roadmap/mc_topic_details/${certificationParticipationId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function userRenderCompetencyPage(accessToken, topicId) {
  return fetch (`${api}/user/mc_roadmap/mc_competency_page/${topicId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}
//------------------------------------------------------------------------------------------------------

export function userFlowChartDisplay(accessToken, roadmapId){
  return fetch(`${api}/user/mc_competency_flow_chart/${roadmapId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function userRenderResources(accessToken, competencyId, certificationLevelId) {
  return fetch (`${api}/user/mc_roadmap/competency/resources/${competencyId}/${certificationLevelId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function userRateInternalResource(accessToken, values){
  values = toSnake(values)
  return fetch(`${api}/user/internal_resource_rating`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function userRateExternalResource(accessToken, values){
  values = toSnake(values)
  return fetch(`${api}/user/external_resource_rating`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function userCheckPreviousInternalRating(accessToken, resourceId) {
  return fetch (`${api}/user/mc_roadmap/internal/check_previous_rating/${resourceId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function userCheckPreviousExternalRating(accessToken, resourceId) {
  return fetch (`${api}/user/mc_roadmap/external/check_previous_rating/${resourceId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function uploadAdminResource(accessToken, formData, mcCompetencyId, type) {
  return fetch(`${api}/admin/mc_competency/resources/new_upload/${mcCompetencyId}/${type}`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

export function externalUserActivity(accessToken, values) {
  values = toSnake(values)
  return fetch(`${api}/user/mc_roadmap/external/update_user_activity/`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function internalUserActivity(accessToken, values) {
  values = toSnake(values)
  return fetch(`${api}/user/mc_roadmap/internal/update_user_activity/`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function fetchAdminTpoResource(accessToken) {
  return fetch (`${api}/admin/tpo/render_resources`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function uploadAdminTPOResource(accessToken, formData) {
  return fetch(`${api}/admin/tpo/new_resource/upload`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

export function addAdminTPOResource(accessToken, values){
  values = toSnake(values)
  return fetch(`${api}/admin/tpo/new_resource/add`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function renderUserTPOResource(accessToken) {
  return fetch (`${api}/user/tpo/fetch_resources`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function userTPOActivity(accessToken, values) {
  values = toSnake(values)
  return fetch(`${api}/user/tpo_resources/update_user_activity/`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function userCheckPreviousTPORating(accessToken, tpoResourceId) {
  return fetch (`${api}/user/tpo_resources/check_previous_rating/${tpoResourceId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function fetchAdminTQResource(accessToken) {
  return fetch (`${api}/admin/tq/render_resources`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function uploadAdminTQResource(accessToken, formData) {
  return fetch(`${api}/admin/tq/new_resource/upload`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

export function addAdminTQResource(accessToken, values){
  values = toSnake(values)
  return fetch(`${api}/admin/tq/new_resource/add`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function renderUserTQResource(accessToken) {
  return fetch (`${api}/user/tq/fetch_resources`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function userTQActivity(accessToken, values) {
  values = toSnake(values)
  return fetch(`${api}/user/tq_resources/update_user_activity/`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function userCheckPreviousTQRating(accessToken, tpoResourceId) {
  return fetch (`${api}/user/tq_resources/check_previous_rating/${tpoResourceId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function renderUserBookmarkedResources(accessToken) {
  return fetch (`${api}/user/learning_path/render_bookmarked_resources`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminTQUpdateResource(accessToken, values, tqResourceId, type) {
  values = toSnake(values)
  return fetch(`${api}/admin/tq/existing_resource/modify/${tqResourceId}/${type}`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function adminTQUpdateDocResource(accessToken, formData, tqResourceId, type) {
  return fetch(`${api}/admin/tq/existing_resource/modify/${tqResourceId}/${type}`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

export function adminTPOUpdateResource(accessToken, values, tpoResourceId, type) {
  values = toSnake(values)
  return fetch(`${api}/admin/tpo/existing_resource/modify/${tpoResourceId}/${type}`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function adminTPOUpdateDocResource(accessToken, formData, tpoResourceId, type) {
  return fetch(`${api}/admin/tpo/existing_resource/modify/${tpoResourceId}/${type}`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

export function adminExtUpdateDocResource(accessToken, formData, extResourceId, type) {
  return fetch(`${api}/admin/external/existing_resource/modify/${extResourceId}/${type}`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

export function adminExtUpdateResource(accessToken, values, extResourceId, type) {
  values = toSnake(values)
  return fetch(`${api}/admin/external/existing_resource/modify/${extResourceId}/${type}`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function adminIntUpdateDocResource(accessToken, formData, intResourceId, type) {
  return fetch(`${api}/admin/internal/existing_resource/modify/${intResourceId}/${type}`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

export function adminIntUpdateResource(accessToken, values, intResourceId, type) {
  values = toSnake(values)
  return fetch(`${api}/admin/internal/existing_resource/modify/${intResourceId}/${type}`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function adminTPODisableResource(accessToken, tpoResourceId) {
  return fetch(`${api}/admin/tpo/disable_resource/${tpoResourceId}`, {
    method: 'POST',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminTQDisableResource(accessToken, tqResourceId) {
  return fetch(`${api}/admin/tq/disable_resource/${tqResourceId}`, {
    method: 'POST',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminExternalDisableResource(accessToken, externalResourceId) {
  return fetch(`${api}/admin/mc_external/disable_resource/${externalResourceId}`, {
    method: 'POST',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminInternalDisableResource(accessToken, internalResourceId) {
  return fetch(`${api}/admin/mc_internal/disable_resource/${internalResourceId}`, {
    method: 'POST',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminCompetencyUpdate(accessToken, values, competencyId) {
  values = toSnake(values)
  return fetch(`${api}/admin/roadmap/competency/modify/${competencyId}`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function adminRoadmapUpdate(accessToken, values, roadmapId) {
  values = toSnake(values)
  return fetch(`${api}/admin/roadmap/modify/${roadmapId}`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function downloadTPOReport(accessToken, testCycleName, rollNumber){
  return fetch(`${api}/tpo/report/gen/${rollNumber}/${testCycleName}`, {
    method: 'GET',
    headers: getHeader(accessToken),
   responseType: 'application/pdf',
  }).then((resp) => {
      let contentType = (resp.headers.get('content-type'))
      let contentTypeVal = "application/pdf"
      if(contentType == contentTypeVal){
        return resp.blob();
      }else{
        return resp.blob();    
      }
   })
}

export function downloadAdminTPOReport(accessToken, tpoIndScoreId){
  return fetch(`${api}/tpo/report/gen/${tpoIndScoreId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
   responseType: 'application/pdf',
  }).then((resp) => {
      let contentType = (resp.headers.get('content-type'))
      let contentTypeVal = "application/pdf"
      if(contentType == contentTypeVal){
        return resp.blob();
      }else{
        return resp.blob();    
      }
   })
}

//------------------------------------------------------------------------------------------------------------------//
//API to display all the Active roadmaps than displaying based on the registration
//------------------------------------------------------------------------------------------------------------------//

export function userRenderAllRoadmaps(accessToken) {
  return fetch(`${api}/user/mc_roadmap/display_all_roadmap`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getOpportunityTypes(accessToken) {
  return fetch(`${api}/opportunity_types`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}


export function userFetchRoadmapCompetency(accessToken, roadmapId) {
  return fetch (`${api}/user/mc_roadmap/fetch_mc_competency/${roadmapId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function userRenderCompetenciesAll(accessToken, roadmapId) {
  return fetch (`${api}/user/display/mc_roadmap/competencies/${roadmapId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}
//------------------------------------------------------------------------------------------------------------------//
//API - End
//------------------------------------------------------------------------------------------------------------------//

//------------------------------------------------------------------------------------------------------------------//
//API - To fetch all the resource for the Admin Consolidated view
//------------------------------------------------------------------------------------------------------------------//

export function adminRenderAllResources(accessToken) {
  return fetch(`${api}/admin/mc_roadmap/resources/render_all_resources`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

//------------------------------------------------------------------------------------------------------------------//
//API - End
//------------------------------------------------------------------------------------------------------------------//

export function searchByOpportunityType(accessToken, opportunity_type_id, searchByOpportunityType) {
  return fetch(`${api}/opportunities/search/type/${opportunity_type_id}/${searchByOpportunityType}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getOpportunityCategories(accessToken) {
 
  return fetch(`${api}/categories/opportunities`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

//------------------------------------------------------------------------------------------------------------------//
//API - To fetch all the Swot Tags
//------------------------------------------------------------------------------------------------------------------//

export function fetchUserSwotTags(accessToken) {
  return fetch(`${api}/user/learning_path/fetch_swot_tags`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

//------------------------------------------------------------------------------------------------------------------//
//API - End
//------------------------------------------------------------------------------------------------------------------//

//------------------------------------------------------------------------------------------------------------------//
//API - To add User Associations
//------------------------------------------------------------------------------------------------------------------//

export function insertUserSwotAssociations(accessToken, values) {
  values = toSnake(values)
  return fetch(`${api}/user/learning_path/user_swot_associations`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}
//------------------------------------------------------------------------------------------------------------------//
//API - End
//------------------------------------------------------------------------------------------------------------------//

//------------------------------------------------------------------------------------------------------------------//
//API - To delete the particular User Association
//------------------------------------------------------------------------------------------------------------------//

export function deleteUserSwotAssociations(accessToken, associationId) {
  return fetch(`${api}/user/learning_path/delete/user_swot_associations/${associationId}`, {
    method: 'POST',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}
//------------------------------------------------------------------------------------------------------------------//
//API - End
//------------------------------------------------------------------------------------------------------------------//

//------------------------------------------------------------------------------------------------------------------//
//API - To render all the archived resources
//------------------------------------------------------------------------------------------------------------------//

export function renderUserArchivedResources(accessToken) {
  return fetch (`${api}/user/learning_path/render_archived_resources`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}
//------------------------------------------------------------------------------------------------------------------//
//API - End
//------------------------------------------------------------------------------------------------------------------//

export function miebAchievements(accessToken) {
  return fetch(`${api}/mieb_achievements`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}
//------------------------------------------------------------------------------------------------------------------//
//Learning Resource Admin - API Begins
//------------------------------------------------------------------------------------------------------------------//

export function getResponse(accessToken, url) {
  return fetch (`${api}/${url}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getResourceDetails(accessToken, url, values) {
  return fetch (`${api}/${url}`, {
    method: 'GET',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function adminAddLearningTaxonomy(accessToken, values) {
  return fetch(`${api}/learning_taxonomy`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function updateTaxonomyDetails(accessToken, id, values) {
  return fetch(`${api}/learning_taxonomy/${id}`, {
    method: 'PUT',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function adminAddLearningResource(accessToken, formData) {
  return fetch(`${api}/learning_resource`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

export function updateLearningResource(accessToken, id, formData) {
  return fetch(`${api}/learning_resource/${id}`, {
    method: 'PUT',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

//------------------------------------------------------------------------------------------------------------------//
//Learning Resource Admin - API Ends
//------------------------------------------------------------------------------------------------------------------//

export function downloadMIEBReport(accessToken, mieb_cert_id, ){
  return fetch(`${api}/mieb/report/gen/${mieb_cert_id}`, {
    method: 'GET',
    headers: getHeader(accessToken),
   responseType: 'application/pdf',
  }).then((resp) => {
      let contentType = (resp.headers.get('content-type'))
      let contentTypeVal = "application/pdf"
      if(contentType == contentTypeVal){
        return resp.blob();
      }else{
        return resp.blob();    
      }
   })
}

//Stopgap arrangement for TQ report download.
//To be modifid once the actual functionality is implemented
export function tqAchievements(accessToken) {
  return fetch(`${api}/tq_achievements`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function mcUserReportLink(accessToken) {
  return fetch(`${api}/mc_user_cert_report`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function fcUserReportLink(accessToken) {
  return fetch(`${api}/fc_user_cert_report`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

//Inst Group Report apis start
export function getInstGroupReportEligibility(accessToken) {
  return fetch(`${api}/tpo/institution/report/eligibility`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function downloadInstGropuReportReport(accessToken, report_type, test_cycle){
  return fetch(`${api}/tpo/institution/report/gen/${report_type}/${test_cycle}`, {
    method: 'GET',
    headers: getHeader(accessToken),
   responseType: 'application/pdf',
  }).then((resp) => {
      let contentType = (resp.headers.get('content-type'))
      let contentTypeVal = "application/pdf"
      if(contentType == contentTypeVal){
        return resp.blob();
      }else{
        return resp.blob();    
      }
   })
}

//inst group report apis end

//------------------------------------------------------------------------------------------------------------------//
//Learning Resource User - API Begins
//------------------------------------------------------------------------------------------------------------------//

export function getUserResponse(accessToken, url) {
  return fetch (`${api}/${url}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function userUpdateLearningResActivity(accessToken, values) {
  values = toSnake(values)
  return fetch(`${api}/user/learning_resource/update_user_activity`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function userSubmitUserReview(accessToken, values) {
  values = toSnake(values)
  return fetch(`${api}/user/learning_resource_activity/update_user_review`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function insertUserSwotTaxonomies(accessToken, values) {
  values = toSnake(values)
  return fetch(`${api}/user/learning_resource/user_swot_taxonomies`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function deleteUserSwotTaxonomies(accessToken, associationId) {
  return fetch(`${api}/user/learning_resource/delete/user_swot_taxonomies/${associationId}`, {
    method: 'POST',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getAssociatedStandards(accessToken, values) {
  return fetch(`${api}/admin/learning_taxonomy/fetch_associated_standards`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}
//------------------------------------------------------------------------------------------------------------------//
//Learning Resource User - API Ends
//------------------------------------------------------------------------------------------------------------------//

//------------------------------------------------------------------------------------------------------------------//
//User Resource Upload - API Begins
//------------------------------------------------------------------------------------------------------------------//

export function getUserAspects(accessToken) {
  return fetch (`${api}/user/resource_upload/aspect_details`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function userAspectAssociatedStandards(accessToken, values) {
  return fetch(`${api}/user/resource_upload/fetch_associated_standards`, {
     method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function userUploadResource(accessToken, formData) {
  return fetch(`${api}/resource_user_upload`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

export function getUserUploadedResource(accessToken) {
  return fetch (`${api}/resource_user_upload`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function updateUserUploadedResource(accessToken, id, formData) {
  return fetch(`${api}/resource_user_upload/${id}`, {
    method: 'PUT',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

export function userResourceAdminActivity(accessToken, values) {
  return fetch(`${api}/admin/user_resource/status_change`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

//------------------------------------------------------------------------------------------------------------------//
//User Resource Upload - API Ends
//------------------------------------------------------------------------------------------------------------------//

//------------------------------------------------------------------------------------------------------------------//
//Reviewer Dashboard - API Begins
//------------------------------------------------------------------------------------------------------------------//

export function reviewerSearch(accessToken, url, values) {
  values = toSnake(values)
  return fetch(`${api}/${url}`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
  .then(result => toCamel(result))
}

export function adminRegisteredUsersSearch(accessToken, url, values) {
  values = toSnake(values)
  return fetch(`${api}/${url}`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

//------------------------------------------------------------------------------------------------------------------//
//Reviewer Dashboard - API Ends
//------------------------------------------------------------------------------------------------------------------//

//------------------------------------------------------------------------------------------------------------------//
//Affiliate Resource - Admin & User - API Begins
//------------------------------------------------------------------------------------------------------------------//
export function getUserUploadedModules(accessToken) {
  return fetch (`${api}/affiliate_partner`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

//Admin Rewards Dashboard - API Begins
//------------------------------------------------------------------------------------------------------------------//
export function getAdminResponse(accessToken, url) {
  return fetch (`${api}/${url}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function userUploadModule(accessToken, formData) {
  return fetch(`${api}/affiliate_partner`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

export function userAspectAffiliatedStandards(accessToken, values) {
  return fetch(`${api}/user/affiliate_partner/fetch_associated_standards`, {
     method: 'POST',
     headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function patchRewardTypes(accessToken, values) {
  values = toSnake(values)
  return fetch(`${api}/reward_type/${values.id}`, {
    method: 'PATCH',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function updateUserUploadedModule(accessToken, id, formData) {
  return fetch(`${api}/affiliate_partner/${id}`, {
    method: 'PUT',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}
//------------------------------------------------------------------------------------------------------------------//
//Affiliate Resource - Admin & User - API Ends
//------------------------------------------------------------------------------------------------------------------//
export function userDescriptionSearch(accessToken, values) {
  return fetch(`${api}/learning_resource/description/render_resources`, {
     method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

//------------------------------------------------------------------------------------------------------------------//
//Admin Rewards Dashboard - API Ends
//------------------------------------------------------------------------------------------------------------------//

export function tpoRegistrationStatus(accessToken, phone_numbers) {
  return fetch(`${api}/tpo_registration_status/?phone=${phone_numbers}`, {
     method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

// -------------------------------------------------------------------------------------------------------------------------
// Admin Resource of the Day
// -------------------------------------------------------------------------------------------------------------------------
export function getResourceOfTheDay(accessToken) {
  return fetch(`${api}/admin/resource_of_the_day`, {
     method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function updateResourceOfTheDay(accessToken, values) {
  return fetch(`${api}/admin/update_resource_of_the_day`, {
     method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function getQuestionOfTheDay(accessToken) {
  return fetch(`${api}/admin/get_question_of_the_day`, {
     method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function updateSpecificDisplay(accessToken, values) {
  return fetch(`${api}/admin/update_question_display`, {
     method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function postQuestionOfTheDay(accessToken, values) {
  return fetch(`${api}/admin/create_question_of_the_day`, {
     method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function searchResources(accessToken, values) {
  return fetch(`${api}/admin/learning_resource/search_learning_resources`, {
     method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

// -------------------------------------------------------------------------------------------------------------------------
// Admin - Hall Ticket Upload
// -------------------------------------------------------------------------------------------------------------------------
export function uploadHallTicketExcel(accessToken, formData) {
//  const snakeValues = toSnake(values)
  return fetch(`${api}/admin/hall_ticket/upload`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
   // body: JSON.stringify(formData),
      body: formData,
  }).then(resp => resp.json())
}

export function getUploadedExcelFileHistory(accessToken, certificationTypeId, page, uploadType) {
  return fetch(`${api}/admin/hall_ticket/upload/history?certification_type_id=${certificationTypeId}&page=${page}&upload_type=${uploadType}`, {
     method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getHallTicketDetails(accessToken, pageNo, itemsPerPage) {
  return fetch(`${api}/admin/hall_ticket/details/${pageNo}/${itemsPerPage}`, {
     method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getHallTicketUpdateDetails(accessToken, hallticketId, userId) {
  return fetch(`${api}/admin/hallticket_detail/fetch/${hallticketId}/${userId}`, {
     method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function updateHallTicket(accessToken, formData) {
  return fetch(`${api}/admin/hall_ticket/update`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(formData),
      // body: formData,
  }).then(resp => resp.json())
}

export function searchHallTicketDetails(accessToken, formData) {
  return fetch(`${api}/admin/hall_ticket/search`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(formData),
      // body: formData,
  }).then(resp => resp.json())
}

export function getHallTicketVersionDetails(accessToken, hallticketId, userId) {
  return fetch(`${api}/admin/hallticket_detail/fetch_version/${hallticketId}/${userId}`, {
     method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

// ------------------------------------------------------------------------------------------------
// TPO Invoice for Admin
// ------------------------------------------------------------------------------------------------

export function downloadTPOInvoice(accessToken, paymentId){
  return fetch(`${api}/invoice/${paymentId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
   responseType: 'application/pdf',
  }).then((resp) => {
      let contentType = (resp.headers.get('content-type'))
      let contentTypeVal = "application/pdf"
      if(contentType == contentTypeVal){
        console.log('inside if of content type check')
        return resp.blob();
      }else{
        console.log('inside else of content type check')
        return resp.blob();    
      }
   })
}

// ---------------------------------------------------------------------------------------------------
// Purchases
// ---------------------------------------------------------------------------------------------------
export function getPurchasePackages(accessToken, entityId) {
  return fetch(`${api}/purchase_items/show/${entityId}/1`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getPurchaseModules(accessToken,packageId) {
  return fetch(`${api}/purchase_items/purchase_item_and_parent_assosication/${packageId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}


// ---------------------------------------------------------------------------------------------------
// Purchases - Admin
// ---------------------------------------------------------------------------------------------------
export function getPurchaseEntities(accessToken) {
  return fetch(`${api}/purchase_entities/entity_list`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getPurchaseItemType(accessToken) {
  return fetch(`${api}/purchase_item_types/list_item_type`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getPurchaseItem(accessToken, selectedPurchaseItemId, selectedPurchaseEntityId) {
  return fetch(`${api}/purchase_item_types/list_other_purchase_type/${selectedPurchaseItemId}/${selectedPurchaseEntityId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function createPurchaseItem(accessToken, apiInput) {
  return fetch(`${api}/purchase_item_types/create`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(apiInput),
      // body: formData,
  }).then(resp => resp.json())
}

export function getPurchaseItemToView(accessToken, purchaseEntityId, purchaseItemTypeId, pageNo, itemsPerPage) {
  return fetch(`${api}/purchase_item_types/entity_package_module_list/${purchaseEntityId}/${purchaseItemTypeId}/${pageNo}/${itemsPerPage}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getEntityForUpdate(accessToken, purchaseItemId) {
  return fetch(`${api}/purchase_item_types/selected_purchase_item_details/${purchaseItemId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function updatePurchaseItem(accessToken, itemId, apiInput) {
  return fetch(`${api}/purchase_item_types/update/${itemId}`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(apiInput),
      // body: formData,
  }).then(resp => resp.json())
}

export function handleEntititySave(accessToken, apiInput) {
  return fetch(`${api}/purchase_orders/create`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(apiInput),
      // body: formData,
  }).then(resp => resp.json())
}

export function getCartDetails(accessToken) {
  return fetch(`${api}/purchase_orders/display_orders`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function handlePurchasePay(accessToken, paymentId) {
  console.log(paymentId)
  return fetch(`${api}/purchase_orders/purchase_pay/${paymentId}`, {
    method: 'POST',
    headers: getHeader(accessToken),
    // body: JSON.stringify(paymentId),
  }).then(resp => resp.json())
}

export function getPurchaseDiscount(accessToken, cartItemDetails) {
  return fetch(`${api}/purchase_orders/purchase_item_price`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(cartItemDetails),
  }).then(resp => resp.json())
}

export function getAdminPurchaseOrderList(accessToken, page, limit) {
  return fetch(`${api}/admin/purchases/list/${page}/${limit}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getAdminPurchaseOrderDetail(accessToken, purchase_order_id) {
  return fetch(`${api}/admin/purchases/detail/${purchase_order_id}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

// ---------------------------------------------------------------------------------------------------
// TPO Results - 2019
// ---------------------------------------------------------------------------------------------------

export function getTPOTopRankHolders(rankCount, year, pageNo, itemsPerPage) {
  return fetch(`${api}/certification/toppers/top/rankers/${rankCount}/${year}/${pageNo}/${itemsPerPage}`, {
    method: 'GET',
    headers: getHeader(),
  }).then(resp => resp.json())
}

export function getTPOYears() {
  return fetch(`${api}/certification/toppers/years/list`, {
    method: 'GET',
    headers: getHeader(),
  }).then(resp => resp.json())
}

export function getTPORegionalToppers(tpoYear) {
  return fetch(`${api}/certification/toppers/search/region/${tpoYear}`, {
    method: 'GET',
    headers: getHeader(),
  }).then(resp => resp.json())
}

export function getTPOSubjectToppers(tpoYear) {
  return fetch(`${api}/certification/toppers/search/subject/${tpoYear}`, {
    method: 'GET',
    headers: getHeader(),
  }).then(resp => resp.json())
}

export function getTPOSearchResults(searchTerm, searchYear, pageNo, itemsPerPage) {
  return fetch(`${api}/certification/toppers/given/name/org/${searchTerm}/${searchYear}/${pageNo}/${itemsPerPage}`, {
    method: 'GET',
    headers: getHeader(),
  }).then(resp => resp.json())
}

export function getTPOCityToppers(tpoYear) {
  return fetch(`${api}/certification/toppers/search/city/${tpoYear}`, {
    method: 'GET',
    headers: getHeader(),
  }).then(resp => resp.json())
}

export function getTPOTEIToppers(tpoYear) {
  return fetch(`${api}/certification/toppers/by/tei/rank/${tpoYear}`, {
    method: 'GET',
    headers: getHeader(),
  }).then(resp => resp.json())
}

// ------------------------------------------------------------------------------------------------
// TQ Institutional Admin
// ------------------------------------------------------------------------------------------------
export function getTqTypes(accessToken) {
  return fetch(`${api}/tq/types`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function searchUsers(accessToken, values){
  return fetch(`${api}/institutional/search`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function saveInstitutionalTqRegistration(accessToken, values) {
  return fetch(`${api}/centa/tq_certifications`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function getInstitutionTQList(accessToken, pageNo, itemsPerPage) {
  return fetch(`${api}/ins_tq_registrations/${pageNo}/${itemsPerPage}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminInsertingCoupons(accessToken, values) {
  return fetch(`${api}/coupons/insert_coupons`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function adminCouponAllocationRetailManual(accessToken, values) {
  return fetch(`${api}/admin/tq/coupon/retail/allocation`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function adminSearchCoupons(accessToken, values) {
  return fetch(`${api}/coupons/search_coupons`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function getInstitutionList(accessToken) {
  return fetch(`${api}/admin/institutions/list`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getInstitutionCouponDetails(accessToken, institutionId) {
  console.log(institutionId)
  return fetch(`${api}/coupons/institiution/allocation/${institutionId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminAllocateCoupons(accessToken, values) {
  return fetch(`${api}/coupons/allocate/coupons`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function adminUpdateCoupons(accessToken, values, couponId) {
  return fetch(`${api}/coupons/update_coupons/${couponId}`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function adminViewCoupons(accessToken, page, limit){
  return fetch(`${api}/coupons/list_coupons/${page}/${limit}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getGroupInstitutionList(accessToken) {
  return fetch(`${api}/institution_admin/list/institutions`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getCouponDetailsForInstitution(accessToken,institutionId) {
  return fetch(`${api}/ins/allocated/coupons/list/${institutionId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function adminCouponAllocationStatus(accessToken) {
  return fetch(`${api}/coupons/overall/allocated/stat`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function getAllottedCouponDetailsForUser(accessToken, institutionId, pageNo, limit){
  return fetch(`${api}/coupons/institution/registrations/${institutionId}/${pageNo}/${limit}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

export function downloadInstGropuReportAdmin(accessToken, report_type, test_cycle, userId){
  return fetch(`${api}/admin/tpo/institution/report/gen/${report_type}/${test_cycle}/${userId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
   responseType: 'application/pdf',
  }).then((resp) => {
      let contentType = (resp.headers.get('content-type'))
      let contentTypeVal = "application/pdf"
      if(contentType == contentTypeVal){
        return resp.blob();
      }else{
        return resp.blob();    
      }
   })
}

// -------------------------------------------------------------------------------------------------------------------------
// Admin - Change PWA Dashboard banner and Global settings.
// -------------------------------------------------------------------------------------------------------------------------

export function updateGlobalSetting(accessToken, globalId, globalValue ) {
  return fetch(`${api}/admin/dashboard/setting/${globalId}`, {
    method: 'POST',
    headers: getHeader(accessToken),
    body: JSON.stringify(globalValue),
      // body: formData,
  }).then(resp => resp.json())
}


//Generic Post and Put methods - start - POST for Create and PUT for Update
export function postValuesApi(accessToken, url, values) {
  return fetch(`${api}/${url}`, {
    method: 'POST',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}

export function putValuesApi(accessToken, url, values) {
  return fetch(`${api}/${url}`, {
    method: 'PUT',
    headers: getHeader(accessToken),
      body: JSON.stringify(values),
  }).then(resp => resp.json())
}
//Generic Post and Put methods - end

export function getCountryBasedPaymentModes(accessToken, countryId) {
  return fetch(`${api}/country/based/payment_mode_list/${countryId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}

//partial save of user details
export function partialSaveUserInfo(accessToken, apiInput){
  console.log(apiInput)
  return fetch(`${api}/centa/partial/save/user/details`,{
    method: 'PUT',
    headers: getHeader(accessToken),
     body: JSON.stringify(apiInput)
  }).then(resp => resp.json())
}

//Admin Tq report scores upload
export function uploadTqScoreReportExcel(accessToken, formData) {
  return fetch(`${api}/admin/tq_score/report/upload`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

export function fetchTqReportScoreUploadDetails(accessToken, type, pageNo, startId){
  return fetch(`${api}/fetch/list/tq_score/report/details?type=${type}&page=${pageNo}&start_id=${startId}`,{
    method: 'GET',
    headers: getHeader(accessToken),
  }).then(resp => resp.json())
}


//Admin User Import
export function uploadUserImportExcel(accessToken, formData) {
  return fetch(`${api}/admin/user/upload`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

//Admin Seminar User Import
export function uploadSeminarImportExcel(accessToken, formData) {
  return fetch(`${api}/admin/seminar/users/upload`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}

export function downloadAdminSeminarReport(accessToken, seminarUserId){
  return fetch(`${api}/download/seminar/participation/certificate?seminar_user_id=${seminarUserId}`, {
    method: 'GET',
    headers: getHeader(accessToken),
   responseType: 'application/pdf',
  }).then((resp) => {
      let contentType = (resp.headers.get('content-type'))
      let contentTypeVal = "application/pdf"
      if(contentType == contentTypeVal){
        return resp.blob();
      }else{
        return resp.json();    
      }
   })
}

export function uploadNationalAverageImport(accessToken, formData) {
  return fetch(`${api}/admin/national/avg/score/upload`, {
    method: 'POST',
    headers: getHeader(accessToken, null),
      body: formData,
  }).then(resp => resp.json())
}


// WEBPACK FOOTER //
// ./src/api/api.js